export default __webpack_public_path__ + "static/media/Scanner.2b9baa0b.svg";